/* Kit Builder — state machine + add-to-cart.
   Ported from the Claude Design prototype (Kit Builder.dc.html); cart mechanics
   per dev-approach.md §3 (parent holds price, $0 components glued by _kit_id). */
(function () {
  'use strict';

  var root = document.querySelector('[data-kit-builder]');
  if (!root || root.dataset.kbBound) return; // idempotency — survives theme-editor re-renders
  root.dataset.kbBound = 'true';

  var configEl = document.getElementById('kb-config');
  if (!configEl) return;
  var CFG = JSON.parse(configEl.textContent);
  var ORDER = CFG.steps.map(function (s) { return s.id; });

  /* ---------- state ---------- */
  var state = { size: CFG.defaultSize || 'full', sel: {}, gifts: [], savedGifts: null };
  try {
    var saved = JSON.parse(sessionStorage.getItem('kb-state') || 'null');
    if (saved && saved.sel) state = saved;
  } catch (err) { /* fresh state */ }

  function persist() {
    try { sessionStorage.setItem('kb-state', JSON.stringify(state)); } catch (err) { /* noop */ }
  }

  /* ---------- lookups ---------- */
  function step(id) {
    for (var i = 0; i < CFG.steps.length; i++) if (CFG.steps[i].id === id) return CFG.steps[i];
    return null;
  }
  function opt(stepId, key) {
    var s = step(stepId);
    if (!s) return null;
    for (var i = 0; i < s.options.length; i++) if (s.options[i].key === key) return s.options[i];
    return null;
  }
  function gift(key) {
    for (var i = 0; i < CFG.gifts.length; i++) if (CFG.gifts[i].key === key) return CFG.gifts[i];
    return null;
  }
  /* Identity: components live on ONE housing product, so product IDs are
     useless for matching — the full-size variant ID is the canonical
     identity (an option and a gift are "the same product" when they share
     it). Before the catalog is wired (variant=0, preview mode) fall back
     to exact name matching so the pairing rules still demo. */
  var NAME_FALLBACK = { trigger: 'cactus', require: 'helichrysum', exclude: 'blue algae' };
  function fullVariantOf(entry) {
    if (entry.variants) return entry.variants.full || 0; // step option
    return entry.variant || 0;                           // gift
  }
  function sameProduct(a, b) {
    var va = fullVariantOf(a);
    var vb = fullVariantOf(b);
    if (va && vb) return va === vb;
    return a.name && b.name && a.name.toLowerCase().trim() === b.name.toLowerCase().trim();
  }
  function matchesRule(entry, ruleName, nameFragment) {
    var n = (entry.name || '').toLowerCase().trim();
    if (ruleName) return n === ruleName;
    return n.indexOf(nameFragment) !== -1;
  }
  function selectedOptions() {
    return ORDER.map(function (id) { return opt(id, state.sel[id]); }).filter(Boolean);
  }
  function cactusSelected() {
    return selectedOptions().some(function (o) {
      return matchesRule(o, CFG.rules.triggerName, NAME_FALLBACK.trigger);
    });
  }
  function giftUnavailable(g) {
    var dupe = selectedOptions().some(function (o) { return sameProduct(o, g); });
    if (dupe) return 'dupe';
    if (cactusSelected() && matchesRule(g, CFG.rules.excludeName, NAME_FALLBACK.exclude)) return 'excluded';
    return null;
  }
  function requiredGiftKey() {
    if (!cactusSelected()) return null;
    for (var i = 0; i < CFG.gifts.length; i++) {
      if (matchesRule(CFG.gifts[i], CFG.rules.requireName, NAME_FALLBACK.require)) return CFG.gifts[i].key;
    }
    return null;
  }
  function applyGiftRules(gifts) {
    var req = requiredGiftKey();
    var out = gifts.filter(function (key) {
      var g = gift(key);
      return g && !giftUnavailable(g);
    });
    if (req) {
      out = [req].concat(out.filter(function (k) { return k !== req; }));
    }
    return out.slice(0, 2);
  }

  /* ---------- offer ----------
     Always-on when enabled (BUNDLE20/BUNDLE30 auto-applied at ATC). The 24h
     countdown is optional flavor (offer.countdown) — it never gates pricing. */
  var offerDeadline = null;
  if (CFG.offer.enabled && CFG.offer.countdown) {
    try { offerDeadline = parseInt(localStorage.getItem('be-kit-offer-deadline'), 10) || null; } catch (err) { offerDeadline = null; }
    if (!offerDeadline || offerDeadline < Date.now()) {
      offerDeadline = Date.now() + (CFG.offer.hours || 24) * 3600 * 1000;
      try { localStorage.setItem('be-kit-offer-deadline', String(offerDeadline)); } catch (err) { /* noop */ }
    }
  }
  function offerActive() { return !!CFG.offer.enabled; }
  function offerPct() { return state.size === 'trial' ? CFG.offer.pctTrial : CFG.offer.pctFull; }
  function offerCode() { return state.size === 'trial' ? CFG.offer.codeTrial : CFG.offer.codeFull; }

  /* ---------- money ---------- */
  function regularPrice() { return state.size === 'trial' ? CFG.prices.trial : CFG.prices.full; }
  function currentPrice() {
    var reg = regularPrice();
    if (!offerActive()) return reg;
    /* Mirror Shopify's checkout math exactly: the discount amount is FLOORED
       to the cent (verified live: 228.42 @30% → −68.52 → 159.90; 49.88 @20%
       → −9.97 → 39.91). Rounding differently would show a price 1¢ off. */
    var discountCents = Math.floor(reg * offerPct() + 1e-6);
    return (Math.round(reg * 100) - discountCents) / 100;
  }
  function kitValue() {
    var trial = state.size === 'trial';
    var v = 0;
    ORDER.forEach(function (id) {
      var o = opt(id, state.sel[id]);
      if (o) v += trial ? o.values.trial : o.values.full;
    });
    if (!trial) {
      state.gifts.forEach(function (key) {
        var g = gift(key);
        if (g) v += g.value;
      });
    }
    return Math.round(v * 100) / 100;
  }
  function fmt(n) { return '$' + n.toFixed(2); }

  /* ---------- completeness ---------- */
  function gapStepId() {
    for (var i = 0; i < ORDER.length; i++) if (!state.sel[ORDER[i]]) return ORDER[i];
    return null;
  }
  function giftsDone() { return state.size === 'trial' || state.gifts.length === 2; }
  function complete() { return !gapStepId() && giftsDone(); }
  function variantsWired() {
    var trial = state.size === 'trial';
    if (!CFG.parent[state.size]) return false;
    var ok = true;
    ORDER.forEach(function (id) {
      var o = opt(id, state.sel[id]);
      if (o && !(trial ? o.variants.trial : o.variants.full)) ok = false;
    });
    if (!trial) {
      state.gifts.forEach(function (key) {
        var g = gift(key);
        if (g && !g.variant) ok = false;
      });
    }
    return ok;
  }

  /* ---------- render ---------- */
  var els = {
    offer: root.querySelector('[data-kb-offer]'),
    timer: root.querySelector('[data-kb-timer]'),
    bar: root.querySelector('[data-kb-bar]'),
    barOffer: root.querySelector('[data-kb-bar-offer]'),
    barStrike: root.querySelector('[data-kb-bar-strike]'),
    barFixed: root.querySelector('[data-kb-bar-fixed]'),
    barAmount: root.querySelector('[data-kb-bar-amount]'),
    cta: root.querySelector('[data-kb-cta]'),
    sheet: root.querySelector('[data-kb-sheet]'),
    sheetTitle: root.querySelector('[data-kb-sheet-title]'),
    sheetRows: root.querySelector('[data-kb-sheet-rows]'),
    sheetValue: root.querySelector('[data-kb-sheet-value]'),
    sheetPrice: root.querySelector('[data-kb-sheet-price]'),
    sheetOffer: root.querySelector('[data-kb-sheet-offer]'),
    sheetSave: root.querySelector('[data-kb-sheet-save]'),
    sheetPerday: root.querySelector('[data-kb-sheet-perday]'),
    sheetCta: root.querySelector('[data-kb-sheet-cta]'),
    teaserSaved: root.querySelector('[data-kb-teaser-saved]'),
  };
  var addedTimer = null;
  var busy = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render() {
    var trial = state.size === 'trial';
    root.classList.toggle('is-trial', trial);

    // offer block
    var active = offerActive();
    if (els.offer) els.offer.style.display = active ? '' : 'none';

    // step sections + option cards
    ORDER.forEach(function (id) {
      var sec = root.querySelector('[data-kb-step="' + id + '"]');
      if (!sec) return;
      var selKey = state.sel[id];
      var o = opt(id, selKey);
      sec.classList.toggle('is-done', !!o);
      var picked = sec.querySelector('.kb-step__picked');
      if (picked) picked.textContent = o ? '✓ ' + o.name : '';
      sec.querySelectorAll('[data-kb-key]').forEach(function (card) {
        var key = card.getAttribute('data-kb-key');
        var co = opt(id, key);
        var selected = key === selKey;
        card.classList.toggle('is-selected', selected);
        var btn = card.querySelector('[data-kb-select]');
        if (btn) {
          btn.classList.toggle('is-selected', selected);
          btn.textContent = selected ? 'In your kit ✓' : 'Select';
        }
        var val = card.querySelector('.kb-card__value');
        if (val && co) val.textContent = trial ? fmt(co.values.trial).replace('.00', '') + ' value · trial size' : fmt(co.values.full).replace('.00', '') + ' value';
      });
    });

    // gift cards
    root.querySelectorAll('[data-kb-gift]').forEach(function (card) {
      var key = card.getAttribute('data-kb-gift');
      var g = gift(key);
      if (!g) return;
      var why = giftUnavailable(g);
      var selected = state.gifts.indexOf(key) !== -1;
      var locked = selected && requiredGiftKey() === key;
      card.classList.toggle('is-selected', selected && !trial);
      card.classList.toggle('is-unavailable', !!why && !trial);
      card.classList.toggle('is-locked', locked && !trial);
      var stateEl = card.querySelector('.kb-gift__state');
      if (stateEl) stateEl.textContent = why === 'dupe' ? 'Already in your kit' : (CFG.rules.excludeLabel || 'Not offered with the Cactus Moisturizer');
      var btn = card.querySelector('[data-kb-gift-select]');
      if (btn) btn.textContent = selected ? 'In your kit ✓' : 'Select';
    });
    if (els.teaserSaved) {
      els.teaserSaved.classList.toggle('is-visible', trial && !!(state.savedGifts && state.savedGifts.length));
    }

    // sticky bar slots
    ORDER.forEach(function (id) {
      var slot = root.querySelector('[data-kb-slot="' + id + '"]');
      if (!slot) return;
      var o = opt(id, state.sel[id]);
      slot.classList.toggle('is-filled', !!o);
      slot.innerHTML = o ? (o.image ? '<img src="' + esc(o.image) + '" alt="">' : esc(o.abbr)) : esc(step(id).title.charAt(0));
    });
    [0, 1].forEach(function (i) {
      var slot = root.querySelector('[data-kb-slot="gift-' + i + '"]');
      if (!slot) return;
      var g = state.gifts[i] ? gift(state.gifts[i]) : null;
      slot.classList.toggle('is-filled', !!g);
      slot.innerHTML = g ? (g.image ? '<img src="' + esc(g.image) + '" alt="">' : esc(g.abbr)) : 'G';
    });

    // sticky bar price
    var price = currentPrice();
    var value = kitValue();
    var anySel = ORDER.some(function (id) { return state.sel[id]; });
    if (els.barAmount) els.barAmount.textContent = fmt(price);
    if (els.barOffer) {
      els.barOffer.classList.toggle('is-visible', active);
      els.barOffer.textContent = '−' + offerPct() + '% applied';
    }
    if (els.barStrike) {
      var strike = active ? regularPrice() : value;
      var show = active || (value > price);
      els.barStrike.classList.toggle('is-visible', show);
      els.barStrike.textContent = fmt(strike);
    }
    if (els.barFixed) els.barFixed.classList.toggle('is-visible', !anySel && !active);

    // CTA
    var isComplete = complete();
    var label;
    if (!isComplete) {
      var gap = gapStepId();
      label = gap ? (CFG.gapLabels[gap] || 'Keep building') : 'Choose your gifts';
    } else if (!variantsWired()) {
      label = 'Preview only';
    } else if (root.dataset.kbAdded) {
      label = 'Added to bag ✓';
    } else {
      label = 'Add my ritual — ' + fmt(price);
    }
    [els.cta, els.sheetCta].forEach(function (b) {
      if (!b) return;
      b.textContent = label;
      b.classList.toggle('is-ready', isComplete && variantsWired());
      b.disabled = busy;
    });

    renderSheet(price, value);
    persist();
  }

  function renderSheet(price, value) {
    if (!els.sheetRows) return;
    var trial = state.size === 'trial';
    if (els.sheetTitle) els.sheetTitle.textContent = trial ? 'Your ritual — Trial size' : 'Your ritual — Full size';
    var rows = '';
    ORDER.forEach(function (id) {
      var o = opt(id, state.sel[id]);
      rows += sheetRow(o ? {
        img: o.image, abbr: o.abbr, name: o.name, empty: false, free: false,
        value: fmt(trial ? o.values.trial : o.values.full) + ' value', struck: false, target: id, link: 'Change',
      } : {
        abbr: '·', name: 'No ' + CFG.nouns[id] + ' chosen yet', empty: true, free: false, value: '', struck: false, target: id, link: 'Choose',
      });
    });
    if (!trial) {
      [0, 1].forEach(function (i) {
        var g = state.gifts[i] ? gift(state.gifts[i]) : null;
        rows += sheetRow(g ? {
          img: g.image, abbr: g.abbr, name: g.name, empty: false, free: true,
          value: fmt(g.value) + ' value', struck: true, target: 'gifts', link: 'Change',
        } : {
          abbr: 'G', name: 'Gift not chosen yet', empty: true, free: false, value: '', struck: false, target: 'gifts', link: 'Choose',
        });
      });
    }
    els.sheetRows.innerHTML = rows;
    if (els.sheetValue) els.sheetValue.textContent = fmt(value);
    if (els.sheetPrice) els.sheetPrice.textContent = fmt(price);
    if (els.sheetOffer) {
      els.sheetOffer.classList.toggle('is-visible', offerActive());
      els.sheetOffer.textContent = 'New customer offer applied · ' + offerPct() + '% off';
    }
    if (els.sheetSave) {
      els.sheetSave.classList.toggle('is-visible', value > price);
      els.sheetSave.textContent = 'You save ' + fmt(Math.max(0, value - price));
    }
    if (els.sheetPerday) {
      var days = trial ? CFG.supplyDays.trial : CFG.supplyDays.full;
      els.sheetPerday.textContent = '$' + (price / days).toFixed(2) + (trial ? ' a day for about two weeks.' : ' a day for twelve weeks.');
    }
  }

  function sheetRow(r) {
    return '<div class="kb-sheet__row' + (r.empty ? ' is-empty' : '') + '">' +
      '<div class="kb-sheet__thumb">' + (r.img ? '<img src="' + esc(r.img) + '" alt="">' : esc(r.abbr)) + '</div>' +
      '<div style="flex:1;min-width:0;">' +
        '<div class="kb-sheet__name">' + esc(r.name) + '</div>' +
        (r.value || r.free ? '<div class="kb-sheet__meta">' +
          (r.free ? '<span class="kb-sheet__free">Free</span>' : '') +
          '<span class="' + (r.struck ? 'kb-sheet__value--struck' : '') + '">' + esc(r.value) + '</span></div>' : '') +
      '</div>' +
      '<button type="button" class="kb-sheet__link" data-kb-goto="' + esc(r.target) + '">' + esc(r.link) + '</button>' +
    '</div>';
  }

  /* ---------- behaviors ---------- */
  function scrollToSec(id) {
    var el = root.querySelector('[data-kb-step="' + id + '"]') || (id === 'gifts' ? root.querySelector('[data-kb-gifts]') : null);
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.scrollY - 10;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  var scrollTimer = null;
  function scrollNext(fromStep) {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      var idx = ORDER.indexOf(fromStep);
      var after = ORDER.slice(idx + 1).filter(function (id) { return !state.sel[id]; })[0];
      if (after) { scrollToSec(after); return; }
      var before = ORDER.filter(function (id) { return !state.sel[id]; })[0];
      if (!before && state.size === 'full' && state.gifts.length < 2) scrollToSec('gifts');
    }, 320);
  }

  function selectOption(stepId, key) {
    state.sel[stepId] = key;
    if (state.size === 'full') state.gifts = applyGiftRules(state.gifts);
    delete root.dataset.kbAdded;
    render();
    scrollNext(stepId);
  }

  function tapGift(key) {
    if (state.size === 'trial') return;
    var g = gift(key);
    if (!g) return;
    var locked = requiredGiftKey() === key;
    var i = state.gifts.indexOf(key);
    if (i !== -1) {
      if (locked) return;
      state.gifts.splice(i, 1);
    } else {
      if (giftUnavailable(g)) return;
      if (state.gifts.length >= 2) {
        var removable = state.gifts.filter(function (k) { return requiredGiftKey() !== k; });
        if (!removable.length) return;
        state.gifts.splice(state.gifts.indexOf(removable[0]), 1);
      }
      state.gifts.push(key);
    }
    delete root.dataset.kbAdded;
    render();
  }

  function setSize(size) {
    if (state.size === size) return;
    if (size === 'trial') {
      if (state.gifts.length) state.savedGifts = state.gifts.slice();
      state.gifts = [];
      state.size = 'trial';
    } else {
      state.size = 'full';
      state.gifts = applyGiftRules((state.savedGifts || []).slice());
    }
    delete root.dataset.kbAdded;
    render();
  }

  /* ---------- add to cart (dev-approach §3) ---------- */
  function buildItems() {
    var trial = state.size === 'trial';
    var kitId = String(Math.floor(1000 + Math.random() * 9000)); // per-add merge-breaker
    var parentProps = { _kit_id: kitId, _kit_role: 'parent', _kit_size: state.size };
    var items = [];
    var valueTotal = 0;
    ORDER.forEach(function (id) {
      var o = opt(id, state.sel[id]);
      parentProps[CFG.roleLabels[id]] = o.name;
      valueTotal += trial ? o.values.trial : o.values.full;
    });
    if (!trial) {
      parentProps['Free gifts'] = state.gifts.map(function (k) { return gift(k).name; }).join(', ');
      state.gifts.forEach(function (k) { valueTotal += gift(k).value; });
    }
    /* _kit_value: display value per line — the housing variants are $0 with
       no compare-at, so the cart bundle card reads these properties. */
    parentProps._kit_value_total = valueTotal.toFixed(2);
    items.push({ id: CFG.parent[state.size], quantity: 1, properties: parentProps });
    ORDER.forEach(function (id) {
      var o = opt(id, state.sel[id]);
      items.push({ id: trial ? o.variants.trial : o.variants.full, quantity: 1, properties: {
        _kit_id: kitId, _kit_role: id, _kit_name: o.name,
        _kit_value: (trial ? o.values.trial : o.values.full).toFixed(2)
      } });
    });
    if (!trial) {
      state.gifts.forEach(function (k) {
        var g = gift(k);
        items.push({ id: g.variant, quantity: 1, properties: {
          _kit_id: kitId, _kit_role: 'gift', _kit_name: g.name,
          _kit_value: g.value.toFixed(2)
        } });
      });
    }
    return items;
  }

  function addToCart() {
    if (busy) return;
    if (!variantsWired()) {
      console.warn('[kit-builder] Catalog not connected: assign products with Full/Trial variants in the section settings.');
      return;
    }
    busy = true;
    render();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: buildItems(),
        sections: ['mini-cart', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Add to cart failed'); });
        return r.json();
      })
      .then(function (json) {
        var code = offerActive() ? offerCode() : null;
        if (!code) return json;
        /* Apply the bundle code in-cart (Cheeky Part 4) and re-render the
           drawer from THIS response so the allocation shows immediately.
           Never block revenue on the code — checkout accepts it manually. */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            discount: code,
            sections: ['mini-cart', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) { return r.ok ? r.json() : json; })
          .then(function (updated) {
            return updated && updated.sections ? updated : json;
          })
          .catch(function () { return json; });
      })
      .then(function (json) {
        busy = false;
        root.dataset.kbAdded = 'true';
        clearTimeout(addedTimer);
        addedTimer = setTimeout(function () { delete root.dataset.kbAdded; render(); }, 2400);
        closeSheet();
        var mc = document.querySelector('mini-cart');
        if (mc && typeof mc.renderContents === 'function' && json.sections) {
          mc.renderContents(json);
        } else {
          window.location.href = '/cart';
        }
        render();
      })
      .catch(function (err) {
        busy = false;
        console.error('[kit-builder]', err);
        if (els.cta) els.cta.textContent = 'Something went wrong — tap to retry';
        [els.cta, els.sheetCta].forEach(function (b) { if (b) b.disabled = false; });
      });
  }

  function openSheet() { if (els.sheet) { els.sheet.classList.add('is-open'); render(); } }
  function closeSheet() { if (els.sheet) els.sheet.classList.remove('is-open'); }

  /* ---------- one delegated listener (Cheeky pattern) ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('summary') || t.closest('details')) {
      var insideCard = t.closest('[data-kb-key]') || t.closest('[data-kb-gift]');
      if (insideCard && t.closest('.kb-card__more')) return; // let <details> toggle without selecting
    }

    var goto_ = t.closest('[data-kb-goto]');
    if (goto_) { e.preventDefault(); closeSheet(); var target = goto_.getAttribute('data-kb-goto'); setTimeout(function () { scrollToSec(target); }, 120); return; }

    if (t.closest('[data-kb-sheet-close]')) { e.preventDefault(); closeSheet(); return; }

    var slot = t.closest('[data-kb-slot]');
    if (slot) { e.preventDefault(); e.stopPropagation(); var sid = slot.getAttribute('data-kb-slot'); scrollToSec(sid.indexOf('gift') === 0 ? 'gifts' : sid); return; }

    if (t.closest('[data-kb-size-full]')) { e.preventDefault(); e.stopPropagation(); setSize('full'); return; }
    if (t.closest('[data-kb-size-trial]')) { e.preventDefault(); e.stopPropagation(); setSize('trial'); return; }
    if (t.closest('[data-kb-switch-full]')) { e.preventDefault(); setSize('full'); return; }

    if (t.closest('[data-kb-cta]') || t.closest('[data-kb-sheet-cta]')) {
      e.preventDefault(); e.stopPropagation();
      if (complete()) { addToCart(); } else { var gap = gapStepId(); scrollToSec(gap || 'gifts'); }
      return;
    }

    var giftCard = t.closest('[data-kb-gift]');
    if (giftCard) { e.preventDefault(); tapGift(giftCard.getAttribute('data-kb-gift')); return; }

    var card = t.closest('[data-kb-key]');
    if (card) {
      e.preventDefault();
      selectOption(card.closest('[data-kb-step]').getAttribute('data-kb-step'), card.getAttribute('data-kb-key'));
      return;
    }

    if (t.closest('[data-kb-bar]')) { openSheet(); }
  });

  /* size toggle active states */
  function renderSizeToggle() {
    var full = root.querySelector('[data-kb-size-full]');
    var trial = root.querySelector('[data-kb-size-trial]');
    if (full) full.classList.toggle('is-active', state.size === 'full');
    if (trial) trial.classList.toggle('is-active', state.size === 'trial');
  }
  var origRender = render;
  render = function () { origRender(); renderSizeToggle(); };

  /* countdown tick — optional flavor only; pricing never depends on it */
  if (CFG.offer.enabled && CFG.offer.countdown && offerDeadline && els.timer) {
    setInterval(function () {
      var ms = Math.max(0, offerDeadline - Date.now());
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);
      var p = function (n) { return String(n).padStart(2, '0'); };
      els.timer.textContent = p(h) + ':' + p(m) + ':' + p(s);
    }, 1000);
  } else if (els.timer) {
    els.timer.style.display = 'none';
  }

  state.gifts = state.size === 'full' ? applyGiftRules(state.gifts) : [];
  render();
})();
